import React, { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const images = [{
  src: 'https://cdn.magicpatterns.com/uploads/s8kVpZ9KZZyH9Kwh1FVaCD/WhatsApp_Image_2026-05-12_at_00.25.16.webp',
  label: 'La Tierra como Factor Productivo'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/v6u4ZpYWf41k4PFaHuwYRu/WhatsApp_Image_2026-05-12_at_00.25.17.webp',
  label: 'Banco de Evaluaciones'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/6hpDJy49Q54j166uUMTtPx/WhatsApp_Image_2026-05-12_at_00.25.16_(1).webp',
  label: 'Mercados Agropecuarios'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/1wBMYZ1ETasZ6KsbJTmZuf/WhatsApp_Image_2026-05-12_at_00.25.17_(1).webp',
  label: 'Formas Jurídicas de Organización Rural'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/eFrfJmi69GYSfGrr4d3crw/WhatsApp_Image_2026-05-12_at_00.25.16_(2).webp',
  label: 'Costos Fijos, Variables y Total'
}];
export function KitPreviewCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);
  const goPrev = () => setCurrentIndex(prev => (prev - 1 + images.length) % images.length);
  const goNext = () => setCurrentIndex(prev => (prev + 1) % images.length);
  return <section className="py-10 md:py-16 px-4 bg-brand-card" data-id="element-155">
      <div className="max-w-4xl mx-auto" data-id="element-156">
        <div className="text-center mb-8" data-id="element-157">
          <h2 className="text-2xl md:text-4xl font-black text-white mb-2" data-id="element-158">
            📖 ALGUNAS PÁGINAS DEL KIT
          </h2>
          <p className="text-sm md:text-base text-gray-400 font-medium" data-id="element-159">
            Mirá por dentro: contenido real, listo para llevar al aula
          </p>
        </div>

        <div className="relative bg-brand-dark rounded-2xl border border-brand-accent/30 p-4 md:p-6 shadow-[0_0_30px_rgba(34,197,94,0.1)]" data-id="element-160">
          {/* Image Frame */}
          <div className="relative overflow-hidden rounded-xl bg-white/5 aspect-[3/4] md:aspect-[4/3] max-w-md md:max-w-2xl mx-auto" data-id="element-161">
            {images.map((img, i) => <img key={i} src={img.src} alt={img.label} className={`absolute inset-0 w-full h-full object-contain transition-opacity duration-700 ${i === currentIndex ? 'opacity-100' : 'opacity-0'}`} data-id="element-162" />)}

            {/* Prev/Next Buttons */}
            <button onClick={goPrev} aria-label="Anterior" className="absolute left-2 top-1/2 -translate-y-1/2 bg-brand-accent hover:bg-brand-accentDark text-white rounded-full w-9 h-9 md:w-11 md:h-11 flex items-center justify-center shadow-lg transition-all hover:scale-110" data-id="element-163">
              <ChevronLeft className="w-5 h-5 md:w-6 md:h-6" data-id="element-164" />
            </button>
            <button onClick={goNext} aria-label="Siguiente" className="absolute right-2 top-1/2 -translate-y-1/2 bg-brand-accent hover:bg-brand-accentDark text-white rounded-full w-9 h-9 md:w-11 md:h-11 flex items-center justify-center shadow-lg transition-all hover:scale-110" data-id="element-165">
              <ChevronRight className="w-5 h-5 md:w-6 md:h-6" data-id="element-166" />
            </button>
          </div>

          {/* Caption */}
          <div className="text-center mt-4" data-id="element-167">
            <p className="text-sm md:text-base font-bold text-brand-accent neon-glow" data-id="element-168">
              {images[currentIndex].label}
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-169">
              Página {currentIndex + 1} de {images.length}
            </p>
          </div>

          {/* Dot Indicators */}
          <div className="flex items-center justify-center gap-2 mt-4" data-id="element-170">
            {images.map((_, i) => <button key={i} onClick={() => setCurrentIndex(i)} aria-label={`Ir a página ${i + 1}`} className={`h-2 rounded-full transition-all ${i === currentIndex ? 'bg-brand-accent w-8' : 'bg-white/20 hover:bg-white/40 w-2'}`} data-id="element-171" />)}
          </div>
        </div>
      </div>
    </section>;
}